import React from 'react'
import styled from 'styled-components'
import GD from '../GD'
import { WSMessage } from '../enums'

interface TypingUsersList {
  userUID: string
  chatUID: string
  userName: string
}

const TypingName= styled.p`
  font-weight: 600;
  margin-right: 5px;
`
const UserTypingDiv = styled.div`
  position: fixed;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  bottom: 70px;
  z-index: 1;
  left: 420px;
  width: 100%;
`
const UserTypingPersonDiv = styled.div`
  flex-grow: 1;
  margin-bottom: 8px;
  display: flex;
  align-items:center;
  flex-direction: row;
  width: max-content;
  background-color: ${props => props.theme.color.secondary};
  height: auto;
  border-radius:4px;
  max-height: 24px;
  color: #FFFFFF;
  padding: 0 5px;
  font-size: 10px;
`

// TODO: move GD.WS_MSG.subscribe() into src/managers/...

const TypingIndicator: React.FC = () => {
  const [typingUsersList, setTypingInfo] = React.useState<TypingUsersList[] | []>([])
  const chatUIDRef = React.useRef(null)
  const userUIDRef = React.useRef<string>()

  React.useEffect(() => {
    const updateUserUID = async () => {
      const resp: IProfile | undefined = await GD.GET_PROFILE.request()
      if (!resp) return
      userUIDRef.current = resp?.uid
    }
    
    void updateUserUID()
  }, [])

  React.useEffect(() => {
    const handleTypingMessage = ({ method, data }: { method: string, data: IObjectData | null }) => {
      if (!data) {
        console.error('No data in WS message')
        return
      }

      if(method === WSMessage.CHAT_USER_ENTER && data.my) {
        chatUIDRef.current = data.chatUID
      }

      if (method === WSMessage.MESSAGE_ADD){
        const wasTyping = typingUsersList?.find((user: TypingUsersList) => user.userUID ===  data.user_uid)
        if (!wasTyping) return

        const updatedTypingUsersList = typingUsersList?.filter((user: TypingUsersList) => user.userUID !== data.user_uid)

        setTypingInfo(updatedTypingUsersList)
      }

      if (method === WSMessage.CHAT_USER_EXIT){
        const isMyself = data.my
        if(isMyself) return setTypingInfo([])

        const userWhoExit = typingUsersList?.find((user: TypingUsersList) => user.userUID === data.userUid)
        if (userWhoExit) {
          const updatedTypingUsersList = typingUsersList?.filter((user: TypingUsersList) => user.userUID !== data.userUid)
          setTypingInfo(updatedTypingUsersList)
        }
      }
    }

    GD.WS_MSG.subscribe(handleTypingMessage, 'isTyping')

    return () => {
      GD.WS_MSG.unsubscribe('isTyping')
    }
  }, [typingUsersList])

  return (
    <UserTypingDiv>
      {!!typingUsersList.length &&
        typingUsersList.map((typingPerson, index) => (
          <UserTypingPersonDiv key={typingPerson.userUID ?? index}>
            <TypingName>{typingPerson.userName}</TypingName> is typing...
          </UserTypingPersonDiv>
        ))}
    </UserTypingDiv>
  )
}

export default TypingIndicator